import { useState } from "react";
import { http } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { toast } from "sonner";
import { PAGES, ACTIONS } from "@/lib/access";

const OPTS = [["", "—"], ["on", "Aç"], ["off", "Kapat"], ["reset", "Varsayılan"]];

function Row({ label, hint, value, onChange, testId }) {
  return (
    <div className="flex items-center justify-between gap-3 py-2">
      <div className="min-w-0"><div className="text-sm">{label}</div>{hint && <div className="text-[10px] text-slate-500">{hint}</div>}</div>
      <div className="flex rounded-lg border border-slate-700 overflow-hidden shrink-0" data-testid={testId}>
        {OPTS.map(([v, l]) => (
          <button key={v || "none"} type="button" onClick={() => onChange(v)} data-testid={`${testId}-${v || "none"}`}
                  className={`px-2.5 py-1 text-[11px] font-semibold transition-colors ${value === v
                    ? v === "on" ? "bg-emerald-600 text-white" : v === "off" ? "bg-red-600 text-white" : v === "reset" ? "bg-slate-500 text-white" : "bg-slate-800 text-slate-200"
                    : "text-slate-400 hover:bg-slate-800"}`}>{l}</button>
        ))}
      </div>
    </div>
  );
}

export function BulkPermsDialog({ ids, onClose, onDone }) {
  const [ch, setCh] = useState({});
  const set = (k, v) => setCh((c) => ({ ...c, [k]: v }));
  const items = [...ACTIONS.map((a) => ({ key: a.key, label: a.label, hint: a.hint })),
    ...PAGES.filter((p) => !p.adminOnly).map((p) => ({ key: `page:${p.to}`, label: `Sayfa: ${p.label}` }))];
  const changes = Object.fromEntries(Object.entries(ch).filter(([, v]) => v).map(([k, v]) => [k, v === "on" ? true : v === "off" ? false : null]));
  const n = Object.keys(changes).length;
  const save = async () => {
    try {
      const { data } = await http.post("/users/bulk-permissions", { user_ids: ids, changes });
      toast.success(`${data.updated} kullanıcının yetkisi güncellendi`); onDone();
    } catch (e) { toast.error(e?.response?.data?.detail || "Güncellenemedi"); }
  };
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="bg-slate-900 border-slate-800 max-w-2xl max-h-[90vh] overflow-y-auto" data-testid="bulk-perms-dialog">
        <DialogHeader><DialogTitle>Toplu Yetki Değişikliği · {ids.length} kullanıcı</DialogTitle></DialogHeader>
        <p className="text-xs text-slate-400">Sadece değiştirmek istediğiniz satırları seçin. “—” olanlar dokunulmadan kalır, “Varsayılan” rolün varsayılanına döndürür. Koordinatör hesapları etkilenmez.</p>
        <div className="divide-y divide-slate-800">
          {items.map((it) => <Row key={it.key} {...it} value={ch[it.key] || ""} onChange={(v) => set(it.key, v)} testId={`bulk-${it.key.replace(/[:/]/g, "-")}`} />)}
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose} className="border-slate-700">İptal</Button>
          <Button onClick={save} disabled={!n} className="bg-blue-600 hover:bg-blue-500" data-testid="bulk-perms-save">{n} değişikliği uygula</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
